import { defineMessages } from "react-intl"

/**
 * Available tabs in wealth pages.
 * @type {string}
 */
export const characteristicsPageID = "am.characteristics"
export const performancesPageID = "am.performances"
export const allocationPageID = "am.allocation"
export const documentsPageID = "am.documents"
export const compositionPageID = "am.composition"

export const messages = defineMessages({
  amCharacteristics: {
    id: characteristicsPageID,
    defaultMessage: "Asset Management > Characteristics"
  },
  amPerformances: {
    id: performancesPageID,
    defaultMessage: "Asset Management > Performances"
  },
  amAllocation: {
    id: allocationPageID,
    defaultMessage: "Asset Management > Allocation"
  },
  amDocuments: {
    id: documentsPageID,
    defaultMessage: "Asset Management > Documents"
  },
  amComposition: {
    id: compositionPageID,
    defaultMessage: "Asset Management > Composition"
  }
})

export const routes = [
  {
    path: "/am/characteristics",
    title: "characteristics",
    isVisible: () => true
  },
  {
    path: "/am/performances",
    title: "performances",
    isVisible: () => true
  },
  {
    path: "/am/allocation",
    title: "allocation",
    isVisible: () => true
  },
  {
    path: "/am/documents",
    title: "documents",
    isVisible: () => true
  },
  {
    path: "/am/composition",
    title: "composition",
    isVisible: () => true
  }
]

export default [
  characteristicsPageID,
  performancesPageID,
  allocationPageID,
  documentsPageID,
  compositionPageID
]
